import { BadgeCheck, User } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { TEAM } from "@/data/team";

export const Team = () => {
  return (
    <section id="equipe" data-testid="team-section" className="section-padding scroll-mt-24 bg-background">
      <div className="container-site flex flex-col gap-14">
        <Reveal>
          <SectionHeading
            id="team"
            eyebrow="Equipe"
            title="Profissionais dedicadas ao seu sorriso."
            description="Conheça as cirurgiãs-dentistas responsáveis pelo seu atendimento na RAMALIVE ODONTOLOGIA."
          />
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-2 lg:max-w-4xl" data-testid="team-grid">
          {TEAM.map((member, i) => (
            <Reveal key={member.id} delay={0.08 * i}>
              <article
                data-testid={`team-card-${member.id}`}
                className="card-premium flex h-full flex-col items-start gap-6 p-7 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(20,16,12,0.10)]"
              >
                <div className="relative">
                  <div
                    aria-hidden="true"
                    className="absolute -inset-1.5 rounded-full border border-[hsl(var(--brand-champagne-gold))]/40"
                  />
                  <Avatar className="h-28 w-28 border border-border bg-[hsl(var(--brand-beige))]">
                    {member.photo ? (
                      <AvatarImage
                        src={member.photo}
                        alt={`Foto de ${member.name}`}
                        className="object-cover"
                        data-testid={`team-photo-${member.id}`}
                      />
                    ) : null}
                    <AvatarFallback
                      className="bg-[hsl(var(--brand-beige))] text-[hsl(var(--brand-soft-brown))]"
                      data-testid={`team-avatar-placeholder-${member.id}`}
                      aria-label="Foto em breve"
                    >
                      <span className="flex flex-col items-center gap-1">
                        <User className="h-9 w-9" strokeWidth={1.5} />
                        <span className="font-heading text-sm font-semibold tracking-[0.12em]">{member.initials}</span>
                      </span>
                    </AvatarFallback>
                  </Avatar>
                </div>

                <div className="flex flex-col gap-2">
                  <h3 className="font-heading text-2xl font-semibold text-foreground" data-testid={`team-name-${member.id}`}>
                    {member.name}
                  </h3>
                  <p className="text-sm font-medium text-[hsl(var(--brand-taupe))]">{member.role}</p>
                  <p
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[hsl(var(--brand-soft-brown))]"
                    data-testid={`team-cro-${member.id}`}
                  >
                    <BadgeCheck className="h-4 w-4 text-[hsl(var(--brand-champagne-gold))]" />
                    {member.cro}
                  </p>
                </div>

                <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">{member.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
